import { Grid, Stack, Typography } from "@mui/material"

import { FormikChip } from "../../../../../shared/components/forms/Formik"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { WeekDays } from "../../productGroup/productGroupTypes"

export function WeekDaysField() {
    return (
        <Stack spacing=".5rem">
            <LocalizedStrict id="product-create-availability-week-days-label">
                <Typography variant="subtitle1">Available on:</Typography>
            </LocalizedStrict>
            <Grid container gap={1}>
                {Object.values(WeekDays).map((day) => (
                    <Grid key={day} item>
                        <LocalizedEnum base="product-group-form-week-day" enumValue={day}>
                            <FormikChip id={day} name="availabilityDetails.weekDays" value={day}>
                                {day.toLowerCase()}
                            </FormikChip>
                        </LocalizedEnum>
                    </Grid>
                ))}
            </Grid>
            <LocalizedStrict id="product-create-availability-week-days-helper-text">
                <Typography variant="body2" color="text.secondary">
                    Leave all days unselected to sell the product every day.
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}
